import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerityIconWithBorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_42309_6425)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.25 11.25C1.25 5.72715 5.72715 1.25 11.25 1.25H36.25C41.7728 1.25 46.25 5.72715 46.25 11.25V36.25C46.25 41.7728 41.7728 46.25 36.25 46.25H11.25C5.72715 46.25 1.25 41.7728 1.25 36.25V11.25Z",
			fill: "white",
			shapeRendering: "crispEdges"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_42309_6425)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M27.7044 22.7949V20.9407C27.7044 18.7262 25.9027 16.9239 23.6876 16.9239C21.4725 16.9239 19.6708 18.7255 19.6708 20.9407V22.7949C19.1425 22.914 18.7479 23.3863 18.7479 23.9504V30.1669H28.6273V23.9504C28.6273 23.3856 28.2327 22.9133 27.7037 22.7949H27.7044ZM22.3274 28.9328L22.9616 26.5986C22.5839 26.3582 22.3337 25.9371 22.3337 25.4557C22.3337 24.708 22.9399 24.1025 23.6876 24.1025C24.4353 24.1025 25.0408 24.7087 25.0408 25.4557C25.0408 25.9364 24.7899 26.3582 24.4129 26.5986L25.0471 28.9328H22.3267H22.3274ZM26.3939 22.7647H20.982V20.94C20.982 19.448 22.1957 18.2343 23.6876 18.2343C25.1795 18.2343 26.3939 19.448 26.3939 20.94V22.7647Z",
				fill: "#331863"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M35.8961 16.4788C35.8812 15.6922 35.8669 14.949 35.8669 14.2301C35.8669 13.6668 35.4104 13.2102 34.847 13.2102C30.4853 13.2102 27.1644 11.9567 24.3963 9.26528C24.0003 8.88017 23.3702 8.88031 22.9743 9.26528C20.2065 11.9567 16.8862 13.2102 12.5248 13.2102C11.9615 13.2102 11.5049 13.6668 11.5049 14.2301C11.5049 14.9492 11.4907 15.6926 11.4757 16.4794C11.3359 23.8002 11.1444 33.8265 23.3513 38.0576C23.4595 38.0952 23.5724 38.1139 23.6853 38.1139C23.7981 38.1139 23.9111 38.0952 24.0193 38.0576C36.2271 33.8264 36.0359 23.7998 35.8961 16.4788ZM23.6854 36.0118C13.2164 32.2087 13.3747 23.8776 13.5151 16.5183C13.5236 16.0766 13.5317 15.6485 13.5374 15.2289C17.6224 15.0564 20.889 13.8186 23.6854 11.3826C26.4821 13.8186 29.7492 15.0566 33.8345 15.2289C33.8402 15.6484 33.8483 16.0762 33.8568 16.5176C33.9971 23.8772 34.1552 32.2085 23.6854 36.0118Z",
				fill: "url(#paint0_linear_42309_6425)",
				stroke: "url(#paint1_linear_42309_6425)",
				strokeWidth: .953124
			})]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_42309_6425",
			x: 1.19209e-7,
			y: 1.19209e-7,
			width: 47.5,
			height: 47.5,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1.25,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_dropShadow_42309_6425"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.25 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_42309_6425"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_42309_6425",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_42309_6425",
			x1: 12.7521,
			y1: 31.5746,
			x2: 49.1498,
			y2: 12.7127,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#00CCCC" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .36,
					stopColor: "#009191"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#018384"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .64,
					stopColor: "#007474"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#006F6F"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_42309_6425",
			x1: 12.7521,
			y1: 31.5746,
			x2: 49.1498,
			y2: 12.7127,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#00CCCC" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .36,
					stopColor: "#009191"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#018384"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .64,
					stopColor: "#007474"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#006F6F"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_42309_6425",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 30.5,
				height: 30.5,
				fill: "white",
				transform: "translate(8.4502 8.45007)"
			})
		})
	] })]
});
export default SvgVerityIconWithBorder;
